import {ErrorMessages} from 'constants/Errors';
import {SuccessMessages} from 'constants/Success';

import {AxiosResponse} from 'axios';
import {call, put} from 'redux-saga/effects';
import {beerStyleUpdate} from 'services/beer-styles';
import {setSuccessAC} from 'store/app/appSlice';
import {handleError} from 'store/app/error/saga';
import ApiData from 'typescript/interfaces/ApiData';
import BeerStyle from 'typescript/models/BeerStyle';

import {setUpdatedBeerStyleAC} from '../beerStyleSlice';
import {updateBeerStyleACS} from '../requestAC';

export function* updateBeerStyle(action: ReturnType<typeof updateBeerStyleACS>) {
  const {style, id} = action.payload;

  try {
    const response: AxiosResponse<ApiData<BeerStyle>> = yield call(beerStyleUpdate, style, id);

    yield put(setUpdatedBeerStyleAC(response.data.data));
    yield put(setSuccessAC(SuccessMessages.EDIT_BEER_STYLE));
  } catch (error) {
    yield call(handleError, error, ErrorMessages.BEER_STYLE_UPDATE);
  }
}
